import React, { useState } from "react";
import { ItemType } from "antd/es/menu/interface";
import FlatList from "common/Lists/FlatList";
import BottomDrawer from "common/Drawers/BottomDrawer";
import styled from "styled-components";
import { DropdownProps } from "common/Dropdown/Dropdown";
import DropdownOption from "common/Dropdown/DropdownOption.tsx";

const MobileDropdown = (props: DropdownProps) => {
  const [shouldCloseDrawer, setShouldCloseDrawer] = useState(false);

  const renderOption = ({ item }: { item: ItemType }) => {
    return (
      <DropdownOption item={item} setShouldCloseDrawer={setShouldCloseDrawer} />
    );
  };

  const content = (
    <FlatListWrapper>
      <FlatList data={props.menu?.items || []} renderContent={renderOption} />
    </FlatListWrapper>
  );

  return (
    <BottomDrawer
      content={content}
      title={props.title}
      triggerElement={props.children}
      contentStyle={{ padding: 0 }}
      shouldCloseDrawer={shouldCloseDrawer}
      setShouldCloseDrawer={setShouldCloseDrawer}
      className="mobile-dropdown"
    />
  );
};

export default MobileDropdown;

const FlatListWrapper = styled.div`
  width: 100%;
  flex: 1;
  overflow: hidden;
`;
